<template>
  <div class="list d-flex flex-column">
    <v-simple-table dense>
      <template v-slot:default>
        <thead v-if="head">
          <tr>
            <th class="left-title text-left pl-4 pl-sm-7 pb-4">
              {{headLeftTitle}}
            </th>
            <th v-if="headCenterTitle" class="center-title text-left px-0 pb-4 pl-0">
              {{headCenterTitle}}
            </th>
            <th class="right-title text-left pr-sm-7 pb-4 pl-0">
              {{headRightTitle}}
            </th>
          </tr>
        </thead>
        <tbody v-if="!loading">
          <tr
            v-for="(item, index) in list"
            :key="item.id"
            @click.stop="onClickItem(item)"
            @mouseover.stop="onHoverItem(item, index)"
            class="tr"
          >
            <td class="left-item text-left pl-4 pl-sm-7 pr-0 py-2">
              <div class="content d-flex align-center">
                <div class="text mr-2">{{ item.title }}</div>
                <div class="dots flex-grow-1 mr-1"></div>
              </div>
            </td>
            <td v-if="headCenterTitle" class="center-item text-left px-0 py-2">
              <div class="content d-flex align-center">
                <div class="text mr-2" v-if="item.company"> {{ item.company }}</div>
                <div class="dots flex-grow-1 mr-2"></div>
              </div>
            </td>
            <td class="right-item text-left pr-sm-7 pl-0 py-2">{{ formatTime(new Date(item.date), '.') }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div v-if="loading" class="my-16 progress-wrapper d-flex justify-center align-center">
      <Loader></Loader>
    </div>
    <div v-else-if="list.length === 0" class="my-16 empty py-16">
      <div class="text text-center">暂无数据</div>
    </div>
  </div>
</template>

<script>
import { formatTime } from '@/utils'
import Loader from '@/components/UI/Loader'
export default {
  name: 'List',
  components: { Loader },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => []
    },
    head: {
      type: Boolean,
      default: false
    },
    headLeftTitle: {
      type: String,
      default: '项目名称'
    },
    headCenterTitle: {
      type: String,
      default: ''
    },
    headRightTitle: {
      type: String,
      default: '发布时间'
    }
  },
  data: () => {
    return {
      page: 1
    }
  },
  methods: {
    formatTime,
    onClickItem (item) {
      this.$emit('clickItem', item)
      if (item.messageTypeShow === '0') {
        window.open('/cpu-fe-tender/dist/inquiryflownav/index.html?id=' + item.msgId, '_blank')
      } else if (item.messageTypeShow === '10') {
        window.open('/cpu-fe-tender/dist/inquiryflownav/index.html?messageTypeShow=pricedecisionnotice&id=' + item.msgId, '_blank')
      } else if (item.messageTypeShow === '1') {
        window.open('https://yc.yonyoucloud.com' + item.detailUrl)
      } else if (item.messageTypeShow) {
        window.open('/cpu-fe-tender/dist/tenderflownav/index.html?messageTypeShow=' + item.messageTypeShow + '&id=' + item.msgId + '&projectId=' + item.id + '&enterpriseId=' + item.srcEnterpriseId + '&show=1&type=&supplyEnterpriseId=' + item.srcEnterpriseId, '_blank')
      }
    },
    onHoverItem (item, index) {
      this.$emit('hoverItem', { item, index })
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  .center-title {
    @media (max-width: 480px) {
      display: none;
    }
  }
  .left-title, .right-title, .center-title {
    font-size: 14px;
    color: #000 !important;
    position: relative;
    &:after {
      content: '';
      height: 1px;
      background-color: rgba(0, 0, 0, 0.12);
      width: 100%;
      position: absolute;
      bottom: 6px;
      left: 0;
    }
  }
  .left-item {
    .text {
    }
  }
  .right-title, .right-item {
    width: 100px;
  }
  .center-title, .center-item {
    width: 200px;
    @media (max-width: 480px) {
      display: none;
    }
  }
  .dots {
    border-top: 4px dotted #e6e6e6;
    height: 1px;
  }
  .tr {
    cursor: pointer;
  }
  .pagination {
  }
}
</style>
